var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHaveQuestionsSectionBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1395,
    height: 522,
    viewBox: "0 0 1395 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 236,
    cy: 435,
    r: 86,
    stroke: "#5973CC",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.45,
    cx: 180.5,
    cy: 350.5,
    r: 55.5,
    fill: "#5973CC"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1150.5,
    cy: 258.5,
    r: 60.5,
    fill: "#6587FA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 45.5,
    cy: 349.5,
    r: 44.5,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 79.5,
    cy: 321.5,
    r: 17.5,
    fill: "#6587FA"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 531,
    cy: 84,
    r: 13,
    fill: "#6587FA"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 1224,
    cy: 213,
    r: 204,
    stroke: "#6587FA",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 625.5,
    cy: 94.5,
    r: 93.5,
    stroke: "#8EA6F8",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaveQuestionsSectionBg);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTM5NSIgaGVpZ2h0PSI1MjIiIHZpZXdCb3g9IjAgMCAxMzk1IDUyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuNDUiIGN4PSIyMzYiIGN5PSI0MzUiIHI9Ijg2IiBzdHJva2U9IiM1OTczQ0MiIHN0cm9rZS13aWR0aD0iMiIvPgogIDxjaXJjbGUgb3BhY2l0eT0iMC40NSIgY3g9IjE4MC41IiBjeT0iMzUwLjUiIHI9IjU1LjUiIGZpbGw9IiM1OTczQ0MiLz4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjExNTAuNSIgY3k9IjI1OC41IiByPSI2MC41IiBmaWxsPSIjNjU4N0ZBIi8+CiAgPGNpcmNsZSBvcGFjaXR5PSIwLjIiIGN4PSI0NS41IiBjeT0iMzQ5LjUiIHI9IjQ0LjUiIHN0cm9rZT0iIzY1ODdGQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgPGNpcmNsZSBvcGFjaXR5PSIwLjMiIGN4PSI3OS41IiBjeT0iMzIxLjUiIHI9IjE3LjUiIGZpbGw9IiM2NTg3RkEiLz4KICA8Y2lyY2xlIG9wYWNpdHk9IjAuMiIgY3g9IjUzMSIgY3k9Ijg0IiByPSIxMyIgZmlsbD0iIzY1ODdGQSIvPgogIDxjaXJjbGUgb3BhY2l0eT0iMC4yIiBjeD0iMTIyNCIgY3k9IjIxMyIgcj0iMjA0IiBzdHJva2U9IiM2NTg3RkEiIHN0cm9rZS13aWR0aD0iMiIvPgogIDxjaXJjbGUgb3BhY2l0eT0iMC4xNSIgY3g9IjYyNS41IiBjeT0iOTQuNSIgcj0iOTMuNSIgc3Ryb2tlPSIjOEVBNkY4IiBzdHJva2Utd2lkdGg9IjIiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };